import React, { Fragment } from 'react';
import classnames from 'classnames';

import styles from './Home.css';

/*
  Presentational component for the Home
*/
const Home = () => (
  <Fragment>
    <section className={styles.topSection}>
      <article className="flex-row flex-justify-end">
        <div className="left">
          <h1 className="page-title">Airtel Design System consists on a extensive UI Library built from solid foundations and varied elements, resulting in responsive components allowing for flexible compositions.</h1>
        </div>

        <div className="right">
          <div className={styles.homeLayers}></div>
        </div>
      </article>
    </section>

    <section className={classnames('bg-grey flex-grow-1', styles.description)}>
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <p>Branding has become one of the most powerful and strategic tools a company can rely on. The key is to find an “authentic” voice, one that is humble and honest, one that customers believe, and, most importantly, one that can be maintained.</p>
          <p>At Airtel, we always put our clients at the heart of what we do. We strive to enhance their experience with us and build a lasting relationship with them by delivering better results every time. This, reflects not only in our Vision and Values but in all of our branding.</p>
          <p>We are alive to the needs of our customers. We act with passion, energy and a can-do attitude to help our customers realize their dreams. Innovation and an entrepreneurial spirit drive us — if it can’t be done, we’ll find a way. Airtel is for everyone — we champion diversity, recognizing the breadth and depth of the communities we serve. We work with them, anticipating, adapting and delivering solutions that enrich their lives. We do this by having an open mind and embracing change. We live the same lives as our customers, sharing the same joys and the same pains. We never forget that they are why we exist. We act with due humility, always open and honest, to achieve mutual respect.</p>
          <p>More than just it’s logo, Airtel is its tone of voice and its display of true points of distinction. Charged with energy, creativity and a team driven by an ambition to become the most admired Telecom service provider globally.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

Home.displayName = 'Home';

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js